import { useQualityContentsContext } from '../contexts/QualityContentsContext';

const useQualityContents = () => {
    return useQualityContentsContext();
}

export default useQualityContents
